/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when an Entity could not be removed
 * @export
 * @class EntityCouldNotRemoveEntityError
 * @extends {Error}
 */
export class EntityCouldNotRemoveEntityError extends Error {
  /**
   * Creates an instance of EntityCouldNotRemoveEntityError
   * @param {string} message The Error `message`
   * @memberof EntityCouldNotRemoveEntityError
   */
  constructor(message) {
    super(message);
    this.name = `EntityCouldNotRemoveEntityError`;
  }
}

/**
 * Called when an Entity could not be removed
 * @param {sting} id The `id` of the entity to remove
 * @returns {never} never
 */
const throwEntityCouldNotRemoveEntityError = (id) => {
  throw new EntityCouldNotRemoveEntityError(
    stripIndent(`
    Can not remove entity with id: "${id}".
    Entity does not exist.
    Has it been added?
    `),
  );
};

export default throwEntityCouldNotRemoveEntityError;
